import React, { useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase-config"; // Adjust path as needed
import "../assets/styles/ProposalTimeline.css";

const ProposalTimeline = ({ projectId }) => {
    const [stages, setStages] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProjectData = async () => {
            try {
                const projectRef = doc(db, "projects", projectId);
                const projectSnap = await getDoc(projectRef);

                if (projectSnap.exists()) {
                    const projectData = projectSnap.data();

                    // Convert stages to FullCalendar event format
                    const formattedStages = projectData.stages.map((stage) => ({
                        title: stage.name,
                        start: stage.start,
                        end: stage.end,
                        color: "#007bff", // Blue for events
                    }));

                    setStages(formattedStages);
                } else {
                    console.error("Project not found");
                }
            } catch (error) {
                console.error("Error fetching project timeline:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchProjectData();
    }, [projectId]);

    if (loading) return <p>Loading project timeline...</p>;

    return (
        <div className="proposal-timeline">
            <h2>Project Timeline</h2>
            <p>
                The <strong>Kick-Off Call</strong> will take place within the week before the project starts.
                It is expected that the <strong>Brand Questionnaire</strong> will be completed before the call
                so that we can discuss it during the meeting. Additionally, after each main stage, there will
                be a <strong>revision period</strong> to ensure you like what is being done and to give you an
                opportunity to ask for changes.
            </p>
            <FullCalendar
                plugins={[dayGridPlugin]}
                initialView="dayGridMonth"
                events={stages}
                editable={false} // Make it read-only
                selectable={false}
                height="500px"
            />
        </div>
    );
};

export default ProposalTimeline;